import React, { useState } from 'react';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    TablePagination,
    Link,
    Button,
} from '@mui/material';
import { Publication } from '../../interfaces/ProductosDTOS/Publication';

// Props del componente
interface DataTableProps {
    data: Publication[];
    page: number; // página actual (empieza en 1)
    pageSize: number; // tamaño de página
    totalCount: number; // total de registros
    onPageChange: (newPage: number, newPageSize: number) => void;

    onSelectEid: (eid: string) => void;
}

const DataTable: React.FC<DataTableProps> = ({
    data,
    page,
    pageSize,
    totalCount,
    onSelectEid
}) => {

    return (
        <Paper>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Título</TableCell>
                            <TableCell>Creador</TableCell>
                            <TableCell>Revista</TableCell>
                            <TableCell>Cover Date</TableCell>
                            <TableCell>DOI</TableCell>
                            <TableCell>Opciones</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row) => (
                            <TableRow key={row.eid}>
                                <TableCell>{row.title}</TableCell>
                                <TableCell>{row.creator}</TableCell>
                                <TableCell>{row.publicationName}</TableCell>
                                <TableCell>{row.coverDisplayDate}</TableCell>
                                <TableCell>
                                    <Link
                                        href={`https://doi.org/${row.doi}`}
                                        target="_blank"
                                        rel="noopener"
                                    >
                                        {row.doi}
                                    </Link>
                                </TableCell>
                                <TableCell>
                                    {totalCount > 0 ?
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={() => onSelectEid(row.eid)}
                                    >
                                        Importar
                                    </Button>
                                    : <></>
                                    }
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default DataTable;
